module.exports = __webpack_public_path__ + "static/media/Homepage - Desktop 970x250.f0022ffb.png";